
import React from "react";
import PageLayout from "@/components/PageLayout";
import { CheckCircle } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      title: "Search for Companies",
      description: "Find companies by name or browse through our extensive database of reviewed workplaces.",
    },
    {
      title: "Read Anonymous Reviews",
      description: "Get insights from real employees about company culture, management, and potential red flags.",
    },
    {
      title: "Share Your Experience",
      description: "Help others by anonymously reviewing companies you've worked for, highlighting both positives and red flags.",
    },
    {
      title: "Make Informed Decisions",
      description: "Use our platform to research prospective employers before accepting job offers.",
    },
  ];

  return (
    <PageLayout 
      title="How It Works" 
      description="RedFlags helps you discover what it's really like to work at companies before you join them."
    >
      <div className="space-y-16">
        {/* Steps Section */}
        <section className="space-y-10">
          <h2 className="text-2xl font-semibold text-redflags-dark text-center mb-8">
            Simple Steps to Navigate RedFlags
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className="bg-slate-50 p-6 rounded-xl border border-slate-100 flex flex-col gap-3"
              >
                <div className="flex items-center gap-3">
                  <div className="bg-redflags-red/10 p-2 rounded-full">
                    <CheckCircle className="h-5 w-5 text-redflags-red" />
                  </div>
                  <h3 className="font-medium text-lg text-redflags-dark">{step.title}</h3>
                </div>
                <p className="text-redflags-gray">{step.description}</p>
              </div>
            ))}
          </div>
        </section>
        
        {/* Benefits Section */}
        <section>
          <h2 className="text-2xl font-semibold text-redflags-dark text-center mb-8">
            Why Use RedFlags?
          </h2>
          <div className="bg-slate-50 p-8 rounded-xl border border-slate-100">
            <div className="space-y-6">
              <p className="text-redflags-gray">
                RedFlags was created to bring transparency to the workplace. We believe that job seekers deserve to know what they're getting into before accepting a position, and current employees should have a safe space to voice concerns.
              </p>
              <p className="text-redflags-gray">
                Our platform is designed to be completely anonymous, allowing honest feedback without fear of repercussions. By collecting genuine experiences from employees across industries, we help create more accountable workplaces and empower individuals to make better career decisions.
              </p>
              <p className="text-redflags-gray">
                Whether you're researching a potential employer or sharing insights about your current workplace, RedFlags is your trusted resource for authentic company information.
              </p>
            </div>
          </div>
        </section>
      </div>
    </PageLayout>
  );
};

export default HowItWorks;
